import { decorators, type Decorator as DecoratorType } from './decorators';

export interface DynamicDecoratorProps extends React.HTMLAttributes<SVGElement> {
  decorator?: DecoratorType;
}

export const DynamicDecorator = ({ decorator, ...rest }: DynamicDecoratorProps) => {
  const Decorator = decorator && decorators[decorator];

  if (!Decorator) {
    return null;
  }

  return <Decorator {...rest} />;
};

export { CircleDecorator } from './CustomDecorators/CircleDecorator';
export { HalfStadiumDecorator } from './CustomDecorators/HalfStadiumDecorator';
export { QuadrantDecorator } from './CustomDecorators/QuadrantDecorator';
